export const getReadingTime = (text) => {
    if (!text) return "0 min read";
    const wordsPerMinute = 200; // average reading speed
    const words = text.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / wordsPerMinute);
    return `${minutes} min read`;
};